import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { physiosApi } from '../services/api';
import type { CreatePhysioInput, UpdatePhysioInput } from '../types';

export function usePhysios() {
  return useQuery({
    queryKey: ['physios'],
    queryFn: async () => {
      const response = await physiosApi.getAll();
      return response.data;
    },
  });
}

export function usePhysio(id: number) {
  return useQuery({
    queryKey: ['physios', id],
    queryFn: async () => {
      const response = await physiosApi.getById(id);
      return response.data;
    },
    enabled: !!id,
  });
}

export function useCreatePhysio() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreatePhysioInput) => physiosApi.create(data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['physios'] });
    },
  });
}

export function useUpdatePhysio() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdatePhysioInput }) =>
      physiosApi.update(id, data),
    onSuccess: (_, { id }) => {
      void queryClient.invalidateQueries({ queryKey: ['physios'] });
      void queryClient.invalidateQueries({ queryKey: ['physios', id] });
    },
  });
}

export function useDeletePhysio() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => physiosApi.delete(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['physios'] });
    },
  });
}
